import { Table, Tbody, Td, Th, Thead, Tr } from '@chakra-ui/react';
import { TableInstance } from 'react-table';
import { AdminProfilesTable_UserFragment } from './__generated__/useAdminProfilesTable.graphql';
import { AdminProfilesTablePageSizeSelector, AdminProfilesTablePagination } from './Pagination';
import { AdminProfilesSearchBar } from './SearchBar';

interface Props {
  table: TableInstance<AdminProfilesTable_UserFragment>;
}

export function AdminProfilesTable({ table }: Props) {
  const { getTableProps, getTableBodyProps, headerGroups, prepareRow, page } = table;

  return (
    <Table {...getTableProps()} variant="simple" width="100%">
      <Thead>
        {headerGroups.map((headerGroup) => {
          const headerGroupProps = headerGroup.getHeaderGroupProps();

          return (
            <Tr {...headerGroupProps} key={headerGroupProps.key}>
              {headerGroup.headers.map((column) => {
                const headerProps = column.getHeaderProps();

                return (
                  <Th {...headerProps} key={headerProps.key} color="gray.600">
                    {column.render('Header')}
                  </Th>
                );
              })}
            </Tr>
          );
        })}
      </Thead>
      <Tbody {...getTableBodyProps()}>
        {page.map((row) => {
          prepareRow(row);
          const rowProps = row.getRowProps();

          return (
            <Tr {...rowProps} key={rowProps.key}>
              {row.cells.map((cell) => {
                const cellProps = cell.getCellProps();
                return (
                  <Td {...cellProps} key={cellProps.key}>
                    {cell.render('Cell')}
                  </Td>
                );
              })}
            </Tr>
          );
        })}
      </Tbody>
    </Table>
  );
}

AdminProfilesTable.Pagination = AdminProfilesTablePagination;
AdminProfilesTable.PageSizeSelector = AdminProfilesTablePageSizeSelector;
AdminProfilesTable.SearchBar = AdminProfilesSearchBar;
